import { useEffect, useState } from 'react';
import ProfileDataFormView from './Views/ProfileDataFormView';
import ProfileDataView from './Views/ProfileDataView';
import { EProfileDataViews } from '../Recipe/RecipeEnums';
import { defaultProfessional, Professional, UserAllowedToPrescript } from '../../interface/interface';
import { useRecipeProfessionalData } from '../../components/context/RecipeProfessionalDataContext';

export default function ProfileData(params: {setActiveView: (av: number|undefined) => void, subActiveView:number|undefined, setSubActiveView: (av: number|undefined) => void, prevActiveView:number|undefined, setPrevActiveView: (pav: number|undefined) => void, prevSubActiveView:number|undefined, setPrevSubActiveView: (pav: number|undefined) => void, medereentity: number, professional:Professional, setProfessional:(prof: Professional) => void, secretary: UserAllowedToPrescript|null, setSecretary:(secre: UserAllowedToPrescript) => void, errorProfileDataFields: boolean }) {
    const { setActiveView, subActiveView, setSubActiveView, prevActiveView, setPrevActiveView, prevSubActiveView, setPrevSubActiveView, professional, setProfessional, secretary, setSecretary } = params;
    
    const { profileData } = useRecipeProfessionalData();
    const [activeProfileView, setActiveProfileView] = useState<number>(subActiveView && subActiveView !== 0? subActiveView : (profileData? EProfileDataViews.PROFILEDATAVIEW:EProfileDataViews.PROFILEDATAFORMVIEW));

    const handleEditProfileDataFormView = () => {
        setActiveProfileView(EProfileDataViews.PROFILEDATAFORMVIEW);
    };

    useEffect(() => {
        if (profileData && profileData != undefined && profileData != defaultProfessional && profileData != professional)
            setProfessional(profileData) //si viene de ser editado
    }, [profileData])

    const renderProfileDataView = () => {
        if (activeProfileView === EProfileDataViews.PROFILEDATAFORMVIEW) {
            return <ProfileDataFormView />;
        } else {
            return <ProfileDataView profileData={profileData} edit={handleEditProfileDataFormView} setActiveView={setActiveView} setSubActiveView={setSubActiveView} prevActiveView={prevActiveView} setPrevActiveView={setPrevActiveView} prevSubActiveView={prevSubActiveView} setPrevSubActiveView={setPrevSubActiveView}/>;
        }
    };

    return (
        <div>
            {renderProfileDataView()}
        </div>
    );
}
